export default "/profile/images/close.svg?3635d8a0670ee7df91e9c651a6655fb4";